import * as React from "react";
import { forwardRef } from "react";
const SvgLock = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M20 16H21.4C21.7314 16 22 16.2686 22 16.6V23.4C22 23.7314 21.7314 24 21.4 24H10.6C10.2686 24 10 23.7314 10 23.4V16.6C10 16.2686 10.2686 16 10.6 16H12M20 16V12C20 10.6667 19.2 8 16 8C12.8 8 12 10.6667 12 12V16M20 16H12", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgLock);
export { ForwardRef as ReactComponent };
